import { ReactComponent as LogoIcon } from "../../Asset/pages.svg";
import {ReactComponent as ArrowIcon} from "../../Asset/greaterwhite.svg"
import { useEffect } from "react";
import Aos from "aos";
import "aos/dist/aos.css";
import "./explore.css"

const Explore = () => {
  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);
  return (
    <div className="explore">
      <div className="header">
        <div className="wrap">
          <p>Explore Features</p>
          <h3>
            We offer a range of services designed to simplify and enhance
            maritime logistics. Whether you’re a charterer, shipowner, or
            broker, our platform provides tools and solutions tailored to your
            needs.
          </h3>
          <LogoIcon />
        </div>
      </div>
      <div className="marquee-wrapper">
        <div className="marquee">
          <div className="marquee__inner">
            <span>Scroll to Discover</span>
            <span className="dot">•</span>
            <span>Scroll to Discover</span>
            <span className="dot">•</span>
            <span>Scroll to Explore</span>

            {/* Duplicate to ensure seamless transition */}
            <span>Scroll to Discover</span>
            <span className="dot">•</span>
            <span>Scroll to Discover</span>
            <span className="dot">•</span>
            <span>Scroll to Explore</span>
          </div>
        </div>
      </div>

      <div class="container-down">
        <div class="card">
          <div>
            <h2>Vessel Chartering Made Easy</h2>
            <p>
              Instantly connect charterers with shipowners through a seamless,
              technology-driven platform. Secure the right vessel for your cargo
              with minimal effort and maximum efficiency.
            </p>
          </div>
          <div class="image-container" data-aos="zoom-in">
            <img
              src="https://res.cloudinary.com/du44pwjoi/image/upload/v1736810961/yacht-and-airplane-creative-design-on-smartphone-2024-12-29-20-07-12-utc_1_kg5um1.png"
              alt="1"
            />
          </div>
        </div>

        <div class="card">
          <div class="image-container" data-aos="zoom-in">
            <img
              src="https://res.cloudinary.com/du44pwjoi/image/upload/v1736810961/old-rusty-ship-is-parked-in-the-port-during-a-vibr-2023-11-27-04-59-51-utc_1_fm0zpf.png"
              alt="2"
            />
          </div>
          <div>
            <h2>Vessel Sales and Acquisition</h2>
            <p>
              Simplify the buying and selling of vessels. Our platform ensures
              transparency and streamlined communication for smooth
              transactions.
            </p>
          </div>
        </div>

        <div class="card">
          <div>
            <h2>Stakeholder Collaboration</h2>
            <p>
              Bridge the gap between all maritime stakeholders with tools that
              foster trust, collaboration, and efficiency.
            </p>
          </div>
          <div class="image-container" data-aos="zoom-in">
            <img
              src="https://res.cloudinary.com/du44pwjoi/image/upload/v1736810964/many-oil-crude-gas-tanker-ship-cargo-container-sh-2024-12-08-00-50-51-utc_1_udjbcs.png"
              alt="3"
            />
          </div>
        </div>

        <div class="card">
          <div class="image-container" data-aos="zoom-in">
            <img
              src="https://res.cloudinary.com/du44pwjoi/image/upload/v1736810961/a-person-holding-up-a-transparent-globe-with-dots-2023-11-27-05-16-50-utc_2_q8unyq.png"
              alt=""
            />
          </div>
          <div>
            <h2>Real-Time Insights</h2>
            <p>
              Access up-to-date market intelligence to make informed decisions,
              optimise routes, and maximize profitability.
            </p>
          </div>
        </div>

        <div class="card">
          <div>
            <h2>Sustainability Integration</h2>
            <p>
              Stay ahead of environmental regulations with features designed to
              support greener operations, such as emission tracking and
              compliance tools.
            </p>
          </div>
          <div class="image-container" data-aos="zoom-in">
            <img
              src="https://res.cloudinary.com/du44pwjoi/image/upload/v1736810960/lpg-ship-oil-tanker-ship-red-oil-tanker-ranchore-2024-12-08-00-43-10-utc_1_t8jrka.png"
              alt="5"
            />
          </div>
        </div>
      </div>
      <div class="why-choose-us-section">
        <div class="content-container">
          <div class="text-content">
            <span>WHY CHOOSE US</span>
            <h1>
              Our services are powered by innovation and designed to save you
              time, reduce costs, and simplify the complexities of maritime
              logistics.
            </h1>
            <a href="/ChooseAccount" class="sign-up">
              SIGN UP <ArrowIcon/>
            </a>
          </div>
          <div class="image-content" data-aos="zoom-in">
            <img
              src="https://res.cloudinary.com/dot2onqdb/image/upload/v1732090405/Heavy_Lift_Pipe-lay_Multi_Purpose_Vessel.I15.2k_1_tmbjfy.png"
              alt="Maritime Logistics Ship"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Explore;
